// extracted by mini-css-extract-plugin
module.exports = {"row":"x_cw","title":"x_f","icon":"x_j"};